export interface TaskGroupListProps {
  readonly items: readonly string[];
}

/**
 * ISS's three task groups [Figma `10a · Your next steps` — instances `Section 1`, `Section 2`, `Group 3`].
 *
 * **Numbered, not bulleted, since 2026-09-08.** They were bullets, because `10 · Finish` drew bullets. `10a`
 * draws the same numbered rows the I-9 screen uses — a teal numeral, then the text — and the numbers are
 * not decoration: the groups arrive in sequence, one after the previous is finished, and the second one
 * literally ends *"then when these are complete,"*. A bullet says "three things"; a numeral says "in this
 * order", which is what the paragraph under them is about.
 *
 * A real `<ol>` rather than markers in divs: the list IS the meaning, and a screen reader should announce
 * three items in order. `role="list"` is NOT redundant — Safari strips list semantics from a list styled
 * `list-style: none`, and the markers are drawn by hand because the frame colours them apart from the text.
 */
export function TaskGroupList({ items }: TaskGroupListProps) {
  return (
    // eslint-disable-next-line jsx-a11y/no-redundant-roles -- see the note above: WebKit drops it.
    <ol className="flex w-full list-none flex-col gap-3" role="list">
      {items.map((item, index) => (
        <li className="flex w-full items-start gap-2" key={item}>
          <span aria-hidden className="shrink-0 text-sm leading-5 text-[var(--primary)]">
            {index + 1}
          </span>
          <span className="min-w-0 flex-1 text-sm leading-5 text-[var(--foreground)]">{item}</span>
        </li>
      ))}
    </ol>
  );
}
